import { render, staticRenderFns } from "./english-mock-test-end.vue?vue&type=template&id=c5493b10&scoped=true&"
import script from "./english-mock-test-end.vue?vue&type=script&lang=js&"
export * from "./english-mock-test-end.vue?vue&type=script&lang=js&"
import style0 from "./english-mock-test-end.vue?vue&type=style&index=0&id=c5493b10&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5493b10",
  null
  
)

export default component.exports